var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLauncherButtonLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 2.41395C13.9626 1.0104 11.5984 0.340989 9.22223 0.526362C6.84606 0.711734 4.61424 1.73969 2.92893 3.425C1.24363 5.11031 0.215666 7.34214 0.0302925 9.7183C-0.155079 12.0945 0.514326 14.4587 1.91788 16.385C3.32144 18.3113 5.36684 19.6729 7.68551 20.2245C9.86367 20.7427 12.1484 20.5141 14.1753 19.5827L19.6868 21.451C20.0473 21.5732 20.4458 21.4801 20.715 21.211C20.9841 20.9419 21.0771 20.5433 20.9549 20.1829L19.0866 14.6714C20.0181 12.6445 20.2467 10.3597 19.7285 8.18158C19.1768 5.86291 17.8152 3.81751 15.8889 2.41395Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0078 10.5039C15.0078 9.95158 14.5601 9.50387 14.0078 9.50387H13.9978C13.4456 9.50387 12.9978 9.95158 12.9978 10.5039C12.9978 11.0562 13.4456 11.5039 13.9978 11.5039H14.0078C14.5601 11.5039 15.0078 11.0562 15.0078 10.5039Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0078 10.5039C11.0078 9.95158 10.5601 9.50387 10.0078 9.50387H9.99784C9.44556 9.50387 8.99784 9.95158 8.99784 10.5039C8.99784 11.0562 9.44556 11.5039 9.99784 11.5039H10.0078C10.5601 11.5039 11.0078 11.0562 11.0078 10.5039Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00784 10.5039C7.00784 9.95158 6.56013 9.50387 6.00784 9.50387H5.99784C5.44556 9.50387 4.99784 9.95158 4.99784 10.5039C4.99784 11.0562 5.44556 11.5039 5.99784 11.5039H6.00784C6.56013 11.5039 7.00784 11.0562 7.00784 10.5039Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLauncherButtonLg);
export default __webpack_public_path__ + "static/media/launcher-button-lg.84f46722ab11a649b2ec5c95410d56aa.svg";
export { ForwardRef as ReactComponent };